<template>  
  <MissionDetailScienceGraphicsListGen :uiid="uiid" :isleft="isleft" :mission="currentDetailMission.mission" :tabState="currentDetailMission" @selectGraph="selectGraph($event)" />
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import MissionDetailScienceGraphicsListGen from '@/components/mission/MissionDetailScienceGraphicsListGen.vue'

@Component({
  name: 'MissionDetailScienceGraphicsList',
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  },
  components:{MissionDetailScienceGraphicsListGen}
})
export default class MissionDetailScienceGraphicsList extends Vue {      

    isleft!:boolean
    uiid!:string

    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    selectGraph(graph:any){     
      
      //@ts-ignore
      this.$store.myActions.MISSION_NAVTO_DETAIL({cmp:'MissionDetailScienceGraphics',isleft:!this.isleft,'label':graph.name}).then(() => {
        const tabsMission = !this.isleft? this.currentDetailMission.tabsleft: this.currentDetailMission.tabsright
        //on attend que le composant soit créé
        this.$nextTick(()=> this.$store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsMission.selected}))
      })        
    }

  }
</script>
